export default {
    bindings: {
        'availability': '<',
        'item': '<',
        'getQuantity': '&',
        'resetStaff': '&'
    },
    controller: 'preferredTimeController',
    template: require('../views/preferred.time.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/availability/components/preferred.time.component.js